import React from "react";
import { Modal } from "react-bootstrap";
import { Button } from "../../";
import { ThemedSpan } from "../../utilities";
import { EmailRestrictionConfirmationModalProps } from "./types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ThemedModal from "../../utilities/ThemedModal";

export const EmailRestrictionConfirmationModal = ({
    backdrop = 'static',
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    ...rest
} : Readonly<EmailRestrictionConfirmationModalProps>) => {
    
     const onClose = () : void => proceed!('cancel');

     const onConfirmation = (forceFile: boolean) : void => proceed!(forceFile ? 'send-file' : 'send');

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>
                    <ThemedSpan variant="warning" className="me-1">
                        <FontAwesomeIcon icon={['fas', 'triangle-exclamation']} />
                    </ThemedSpan>
                    <span>Restricted Contact</span>
                </Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <p>
                    One of the recipients selected is marked as a "restricted" email contact.
                    <br />
                    <br />
                    Would you still like to file this email in WealthPro?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" variant="primary" onClick={() => onConfirmation(false)}>Send</Button>
                <Button type="button" variant="secondary" onClick={() => onConfirmation(true)}>Send & File</Button>
                <Button type="button" variant="light" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};